import { useQuery } from "@tanstack/react-query";
import { RotateCcw } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";

import { listDiscrepancies } from "@/api/transfer_receipts";
import { Button } from "@/components/ui/button";
import { AccessDenied, LoadState, isForbidden } from "@/lib/scan-ui/screen";
import { ReceiptCardView } from "@/pages/transfer-receipts/shared";

/** «Расхождения перемещений»: принятое не совпало с отправленным — по всем
 *  складам, ждёт решения (пересчитать / провести по принятому / отменить). */
export function TransferDiscrepancyListPage(): React.ReactElement {
  const navigate = useNavigate();
  const q = useQuery({ queryKey: ["transfer-discrepancies"], queryFn: listDiscrepancies });
  const rows = q.data?.items ?? [];

  return (
    <div className="mx-auto max-w-xl space-y-3">
      <div className="flex items-center justify-between gap-2">
        <div>
          <h1 className="text-xl font-semibold">Расхождения перемещений</h1>
          <p className="text-sm text-muted-foreground">
            Принятое не совпало с отправленным — в 1С ничего не записано, пока не решено.
          </p>
        </div>
        <Button
          variant="outline"
          size="icon"
          aria-label="Обновить"
          onClick={() => void q.refetch()}
          disabled={q.isFetching}
        >
          <RotateCcw className="size-4" />
        </Button>
      </div>
      {q.isError && isForbidden(q.error) ? (
        <AccessDenied error={q.error} className="flex flex-col items-center gap-3 rounded-lg border border-amber-300 bg-amber-50 p-6 text-center" />
      ) : q.isLoading || q.isError ? (
        <LoadState isLoading={q.isLoading} error={q.error} onRetry={() => void q.refetch()} className="flex flex-col items-center gap-3 p-6 text-center" />
      ) : rows.length === 0 ? (
        <p className="py-10 text-center text-sm text-muted-foreground">Расхождений нет.</p>
      ) : (
        <div className="space-y-2">
          {rows.map((r) => (
            <ReceiptCardView
              key={r.session_id}
              row={r}
              onClick={() => navigate(`/transfer-discrepancies/${r.session_id}`)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
